import { BaseService, Service } from "/@/cool";

@Service("packageVersionBind")
class PackageVersionBind extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["waitingBindShopPage"] = prefix + "waitingBindShopPage";
		this.permission["batchBind"] = prefix + "batchBind";
		this.permission["delete"] = prefix + "delete";
		this.permission["page"] = prefix + "page";
	}

	// 待绑定门店分页查询
	waitingBindShopPage(data: any) {
		return this.request({
			url: "/waitingBindShopPage",
			method: "POST",
			data
		});
	}

	// 批量绑定门店到套餐版本
	batchBind(data: any) {
		return this.request({
			url: "/batchBind",
			method: "POST",
			data
		});
	}

	// 删除绑定配置
	delete(data: any) {
		return this.request({
			url: "/delete",
			method: "POST",
			data
		});
	}

	// 绑定记录分页查询
	page(data: any) {
		return this.request({
			url: "/page",
			method: "POST",
			data
		});
	}
}

export default PackageVersionBind;
